module.exports = __webpack_public_path__ + "img/a1-s19.7f4426ab.jpg";